import { Pipe, PipeTransform, inject } from '@angular/core';

import { FieldWebInputTypeEnum, FieldWebInputType } from '@pages/office/models/field-web-input-type.model';
import { DateTimeHelper } from '@pages/office/SingleGridForm/office-form/helpers/date-time.helper';
import { UtilityService } from '@core/services/utility.service';

@Pipe({
  name: 'dateFromJson',
  standalone: true,
})
export class DateFromJsonPipe implements PipeTransform {
  private dateLookupTypes: string[] = [FieldWebInputTypeEnum.date, FieldWebInputTypeEnum.month];
  private utilityService = inject(UtilityService);

  transform(value: string, webInputType: FieldWebInputType, mask?: string): unknown {
    return this.dateLookupTypes.includes(webInputType) ? this.getFormattedValue(value, webInputType, mask) : value;
  }

  private getFormattedValue(value: string, webInputType: FieldWebInputType, mask?: string): string {
    const format =
      mask || (webInputType === FieldWebInputTypeEnum.month ? DateTimeHelper.MONTH_FORMAT : this.utilityService.getDateFormat());
    const date = DateTimeHelper.getJSDateFromString(value);
    return DateTimeHelper.getFormattedValue(date, format.toLocaleUpperCase());
  }
}
